(function () {

    angular
        .module('app.common')
        .filter('trustAsHtml', ['$sce', function ($sce) {
            return $sce.trustAsHtml;
        }]);

})();


// WEBPACK FOOTER //
// ./app/common/filter/trustAsHtmlFilter.js